module.exports = __webpack_public_path__ + "media/images/teams/VERONA-dad70dc1230b577e25cf607636b67c81.png";